// extracted by mini-css-extract-plugin
module.exports = {"forOFor":"styles_forOFor__2ztaj","text":"styles_text__11EoZ","btn":"styles_btn__lVI6Q"};